import { colors } from './colors';
import { breakpoints } from './breakpoints';
import { cursor } from './cursor';

export const tokens = {
  breakpoints,
  colors,
  cursor,
  spacing: {
    0: { value: '0rem' },
  },
};
